// Pobieranie zdarzeń innych urządzeń stronami (bez IndexedDB, żeby dało się to sprawdzić w teście na prawdziwym Postgresie).
// Zakładka: serwer nadaje czas przy wstawieniu, a zapis widać dopiero po zatwierdzeniu transakcji. Zdarzenie wstawione wcześniej,
// ale zatwierdzone po naszym pobraniu, ma czas starszy niż kursor i bez zakładki nie przyszłoby nigdy. Dlatego pierwsza strona
// sięga ZAKLADKA_MS wstecz (duplikaty odrzuca dziennik na urządzeniu), a kursor nigdy się nie cofa.
export const ZAKLADKA_MS = 10 * 60 * 1000;
export const STRON = 20;

const cofnij = (k) => (k ? new Date(Date.parse(k) - ZAKLADKA_MS).toISOString() : null);
const pozniejszy = (a, b) => (!a ? b : !b ? a : a > b ? a : b);

/** adapter.pobierz(od) → { ok, zdarzenia, kursor, wiecej, powod }; dopisz(z) → true, gdy nowe; zapiszKursor(k).
 *  Zwraca { nowe, kursor, powod, wiecej } (wiecej: zostało coś na następną synchronizację). */
export async function pobierzWszystko(adapter, kursor, { dopisz, zapiszKursor = async () => {}, stron = STRON }) {
  let nowe = 0; let od = cofnij(kursor);
  for (let i = 0; i < stron; i++) {
    const p = await adapter.pobierz(od);
    if (!p.ok) return { nowe, kursor, powod: p.powod };
    for (const z of p.zdarzenia) if (await dopisz(z)) nowe++;
    kursor = pozniejszy(kursor, p.kursor); await zapiszKursor(kursor);
    if (!p.wiecej) return { nowe, kursor };
    if (p.kursor === od) return { nowe, kursor, powod: 'na serwerze ponad 1000 zmian z tej samej chwili', wiecej: true }; // strona stoi w miejscu
    od = p.kursor;
  }
  return { nowe, kursor, wiecej: true };
}
